// Components
import { HeaderMenu } from "components"
import { ItemsBuild } from "../Register/ItemBuild"

export default function BuiltItem(): JSX.Element {
  return (
    <section className="container my-5 flex flex-col gap-3">
      <HeaderMenu title="BUILD ITEM" />
      <ItemsBuild />
    </section>
  )
}